import { h, resolveComponent } from 'vue'
import { createRouter, createWebHashHistory } from 'vue-router'

import DefaultLayout from '@/layouts/DefaultLayout'

const UserPage = () => import('@/views/users/UserPage')
const UserCreate = () => import('@/views/users/UserCreate')
const UserEdit = () => import('@/views/users/UserEdit')

const CustomerPage = () => import('@/views/customers/CustomerPage')
const CustomerCreate = () => import('@/views/customers/CustomerCreate')
const CustomerChange = () => import('@/views/customers/CustomerChange')
const CustomerEdit = () => import('@/views/customers/CustomerEdit')

const TaskPage = () => import('@/views/tasks/TaskPage')
const TaskCreate = () => import('@/views/tasks/TaskCreate')
const TaskEdit = () => import('@/views/tasks/TaskEdit')

const NoteCreate = () => import('@/views/tasks/notes/NoteCreate')

const ProspectPage = () => import('@/views/prospects/ProspectPage')

const ReminderPage = () => import('@/views/reminders/ReminderPage')
const ReminderCreate = () => import('@/views/reminders/ReminderCreate')
const ReminderEdit = () => import('@/views/reminders/ReminderEdit')
const ReminderCustomerCreate = () => import('@/views/reminders/ReminderCustomerCreate')

const RevisionPage = () => import('@/views/revisions/RevisionPage')

const ProductTypeCreate = () => import('@/views/product_types/ProductTypeCreate')
const ProductTypeEdit = () => import('@/views/product_types/ProductTypeEdit')
const ProductTypePage = () => import('@/views/product_types/ProductTypePage')

//const ProductsPage = () => import('@/views/products/ProductPage')
const ProductCreate = () => import('@/views/products/ProductCreate')
const ProductEdit = () => import('@/views/products/ProductEdit')

const RelationshipCreate = () => import('@/views/relationships/RelationshipCreate')
const RelationshipEdit = () => import('@/views/relationships/RelationshipEdit')

const InteractionCreate = () => import('@/views/interactions/InteractionCreate.vue')

const FileAreaCreate = () => import('@/views/customers/files_area/FileAreaCreate')

const CarteraEbrokerCreate = () => import('@/views/cartera_ebroker/CarteraEbrokerCreate')
const CarteraEbrokerEdit = () => import('@/views/cartera_ebroker/CarteraEbrokerEdit')
const CarteraEbrokerPage = () => import('@/views/cartera_ebroker/CarteraEbrokerPage')

const TimelinePage = () => import('@/views/timelines/TimelinePage')

const CimaPage = () => import('@/views/cima/CimaPage')

const routes = [
  {
    path: '/',
    name: 'Home',
    component: DefaultLayout,
    redirect: '/dashboard',
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard.vue'),
      },
      {
        path: 'timeline',
        name: 'Timeline',
        component: TimelinePage
      },
      {
        path: 'prospects',
        name: 'Propectos',
        component: ProspectPage,
      },
      {
        path: 'cima',
        name: 'CIMA',
        component: CimaPage,
      },
      {
        path: 'customers',
        name: 'Clientes',
        redirect: 'customers',
        component: {
        render() {
            return h(resolveComponent('router-view'))
          },
        },
        children: [
          {
            path: '',
            name: 'Clientes ',
            meta: { label: 'Clientes' },
            component: CustomerPage
          },
          {
            path: 'create',
            meta: { label: 'Crear Cliente' },
            name: 'Crear Cliente',
            component: CustomerCreate
          },
          {
            path: 'changing/:customerId',
            meta: { label: 'Cargando Cliente' },
            name: 'Cargando Cliente',
            component: CustomerChange
          },
          {
            path: ':id/edit',
            meta: { label: 'Editar Cliente', reuse: false},
            name: 'Editar Cliente',
            component: CustomerEdit,
          },
          {
            path: ':id/products/create',
            meta: { label: 'Crear Producto' },
            name: 'Crear Producto',
            component: ProductCreate
          },
          {
            path: ':customerId/products/:productId/edit',
            meta: { label: 'Editar Producto' },
            name: 'Editar Producto',
            component: ProductEdit
          },
          {
            path: ':customerId/relationships/:relationshipId/edit',
            meta: { label: 'Editar Relación' },
            name: 'Editar Relación',
            component: RelationshipEdit
          },
          {
            path: ':customerId/interactions/create',
            meta: { label: 'Crear Interacción' },
            name: 'Crear Interacción',
            component: InteractionCreate
          },
          {
            path: ':customerId/relationships/create',
            meta: { label: 'Crear Relación' },
            name: 'Crear Relación',
            component: RelationshipCreate
          }
        ]
      },
       {
          path: 'tasks',
          name: 'Tareas',
          redirect: 'tasks',
          component: {
            render() {
              return h(resolveComponent('router-view'))
            },
          },
          children: [
            {
              path: '',
              name: 'Tareas ',
              meta: { label: 'Tareas' },
              component: TaskPage
            },
            {
              path: 'create',
              name: 'Crear Tarea',
              meta: { label: 'Crear Tarea' },
              component: TaskCreate
            },
            {
              path: ':id/edit',
              name: 'Editar Tarea',
              component: TaskEdit ,
              meta: { reuse: false },
            },
            {
              path: ':id/notes/create',
              meta: { label: 'Crear Nota' },
              name: 'Crear Nota',
              component: NoteCreate
            },
            {
              path: ':customerId/create',
              name: 'Crear Tarea con Cliente',
              meta: { label: 'Crear Tarea' },
              component: TaskCreate
            },
            // {
            //   path: ':id/tasks/create',
            //   meta: { label: 'Crear Producto' },
            //   name: 'tasks.create',
            //   component: ProductCreate
            // },
            // {
            //   path: ':customerId/tasks/:productId/edit',
            //   meta: { label: 'Editar Producto' },
            //   name: 'tasks.edit',
            //   component: ProductEdit
            // }
          ]
        },
        {
          path: 'reminders',
          redirect: 'reminders',
          name: 'Recordatorios',
          component: {
            render() {
              return h(resolveComponent('router-view'))
            },
          },
          children: [
            {
              path: '',
              name: 'Recordatorios ',
              meta: { label: 'Recordatorios' },
              component: ReminderPage
            },
            {
              path: 'create',
              name: 'Crear Recordatorio',
              meta: { label: 'Crear Recordatorio' },
              component: ReminderCreate
            },
            {
              path: ':id/edit',
              meta: { label: 'Editar Recordatorio' },
              name: 'Editar Recordatorio',
              component: ReminderEdit
            },
            {
              path: 'create/:customerId/reminder',
              name: 'Crear Recordatorio con cliente',
              meta: { label: 'Crear Recordatorio' },
              component: ReminderCustomerCreate
            },
          ]
        },
        {
          path: 'revisions',
          redirect: 'revisions',
          name: 'Revisión',
          component: {
            render() {
              return h(resolveComponent('router-view'))
            },
          },
          children: [
            {
              path: '',
              name: 'Revisión ',
              meta: { label: 'Revisión' },
              component: RevisionPage
            }
          ]
        }, 
        {
          path: 'files_area',
          redirect: 'files_area',
          component: {
            render() {
              return h(resolveComponent('router-view'))
            },
          },
          children: [
            {
              path: ':customerId/create',
              name: 'Crear Archivo',
              meta: { label: 'Crear Archivo' },
              component: FileAreaCreate
            }
          ]
        },
        {
          path: 'users',
          name: 'Usuarios',
          meta: { label: 'Usuarios' },
          component: {
            render() {
              return h(resolveComponent('router-view'))
            },
          },
          children: [
            {
              path: '',
              name: 'Usuarios ',
              meta: { label: 'Usuarios' },
              component: UserPage
            },
            {
              path: 'create',
              name: 'Crear Usuario',
              meta: { label: 'Crear Usuario' },
              component: UserCreate
            },
            {
              path: ':id/edit',
              meta: { label: 'Editar Usuario' },
              name: 'Editar Usuario',
              component: UserEdit
            }
          ]
        },
        {
          path: 'product_types',
          name: 'Tipo de Producto',
          redirect: 'product_types',
          component: {
            render() {
              return h(resolveComponent('router-view'))
            },
          },
          children: [
            {
              path: '',
              name: 'Tipo de Producto ',
              meta: { label: 'Tipo de Producto' },
              component: ProductTypePage
            },
          {
              path: 'create',
              name: 'product_types.create',
              meta: { label: 'Crear Tipo de Producto' },
              component: ProductTypeCreate
            }, 
            {
              path: ':id/edit',
              meta: { label: 'Editar Tipo de Producto' },
              name: 'Editar Tipo de Producto',
              component: ProductTypeEdit
            },
          ]
        },
        {
          path: 'cartera_ebroker',
          redirect: 'cartera_ebroker',
          component: { render(c) { return c('router-view') } },
          children: [
            {
              path: '',
              name: 'cartera_ebroker.index',
              meta: { label: 'Cartera ebroker' },
              component: CarteraEbrokerPage
            },
            {
              path: 'create',
              name: 'cartera_ebroker.create',
              meta: { label: 'Crear Cartera ebroker' },
              component: CarteraEbrokerCreate
            },
            {
              path: ':id/edit',
              meta: { label: 'Editar Cartera ebroker' },
              name: 'cartera_ebroker.edit',
              component: CarteraEbrokerEdit
            },
          ]
        },
     ],
  },

  {
    path: '/pages',
    redirect: '/pages/404',
    name: 'Pages',
    component: {
      render() {
        return h(resolveComponent('router-view'))
      },
    },
    children: [
      {
        path: '404',
        name: 'Page404',
        component: () => import('@/views/pages/Page404'),
      },
      {
        path: '500',
        name: 'Page500',
        component: () => import('@/views/pages/Page500'),
      },
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/views/pages/Login'),
      },
      {
        path: 'register',
        name: 'Register',
        component: () => import('@/views/pages/Register'),
      },
    ],
  },
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})

export default router
